import React, {
  createContext,
  useContext,
  useState,
  useEffect,
} from "react";
import { DEFAULT_THEME } from "./theme";
import { useStoreInfo } from "../context/StoreInfoContext";

const ThemeContext = createContext(DEFAULT_THEME);

export const ThemeProvider = ({ children }) => {
  // Get store info from StoreInfoContext (which uses resolve-host API)
  const storeInfoContext = useStoreInfo();
  const storeInfo = storeInfoContext?.storeInfo;
  const [theme, setTheme] = useState(DEFAULT_THEME);

  useEffect(() => {
    if (storeInfo?.theme?.settings) {
      const themeSettings = { ...storeInfo.theme.settings };

      if (
        themeSettings.company_banners &&
        typeof themeSettings.company_banners === "string"
      ) {
        try {
          const trimmed = themeSettings.company_banners.trim();
          if (trimmed.startsWith("[") || trimmed.startsWith("{")) {
            themeSettings.company_banners = JSON.parse(
              themeSettings.company_banners
            );
          } else {
            themeSettings.company_banners = themeSettings.company_banners
              .split(",")
              .map((banner) => banner.trim())
              .filter((banner) => banner.length > 0);
          }
        } catch (parseError) {
          console.warn(
            "Failed to parse company_banners as JSON, using comma-separated parsing:",
            parseError
          );
          themeSettings.company_banners = themeSettings.company_banners
            .split(",")
            .map((banner) => banner.trim())
            .filter((banner) => banner.length > 0);
        }
      }

      if (
        !Array.isArray(themeSettings.company_banners) ||
        themeSettings.company_banners.length === 0
      ) {
        themeSettings.company_banners = [];
      }

      setTheme({ ...DEFAULT_THEME, ...themeSettings });
    }
  }, [storeInfo]);

  return (
    <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
